const actions = {
    // List
    ONBOARDING_KB_LIST_BEGIN: 'ONBOARDING_KB_LIST_BEGIN',
    ONBOARDING_KB_LIST_SUCCESS: 'ONBOARDING_KB_LIST_SUCCESS',
    ONBOARDING_KB_LIST_ERR: 'ONBOARDING_KB_LIST_ERR',

    // Add
    ONBOARDING_KB_ADD_BEGIN: 'ONBOARDING_KB_ADD_BEGIN',
    ONBOARDING_KB_ADD_SUCCESS: 'ONBOARDING_KB_ADD_SUCCESS',
    ONBOARDING_KB_ADD_ERR: 'ONBOARDING_KB_ADD_ERR',

    // Update
    ONBOARDING_KB_UPDATE_BEGIN: 'ONBOARDING_KB_UPDATE_BEGIN',
    ONBOARDING_KB_UPDATE_SUCCESS: 'ONBOARDING_KB_UPDATE_SUCCESS',
    ONBOARDING_KB_UPDATE_ERR: 'ONBOARDING_KB_UPDATE_ERR',

    // Delete
    ONBOARDING_KB_DELETE_BEGIN: 'ONBOARDING_KB_DELETE_BEGIN',
    ONBOARDING_KB_DELETE_SUCCESS: 'ONBOARDING_KB_DELETE_SUCCESS',
    ONBOARDING_KB_DELETE_ERR: 'ONBOARDING_KB_DELETE_ERR',

    // Sync
    ONBOARDING_KB_SYNC_BEGIN: 'ONBOARDING_KB_SYNC_BEGIN',
    ONBOARDING_KB_SYNC_SUCCESS: 'ONBOARDING_KB_SYNC_SUCCESS',
    ONBOARDING_KB_SYNC_ERR: 'ONBOARDING_KB_SYNC_ERR',

    onboardingKbListBegin: () => ({ type: actions.ONBOARDING_KB_LIST_BEGIN }),
    onboardingKbListSuccess: (data) => ({ type: actions.ONBOARDING_KB_LIST_SUCCESS, data }),
    onboardingKbListErr: (err) => ({ type: actions.ONBOARDING_KB_LIST_ERR, err }),

    onboardingKbAddBegin: () => ({ type: actions.ONBOARDING_KB_ADD_BEGIN }),
    onboardingKbAddSuccess: () => ({ type: actions.ONBOARDING_KB_ADD_SUCCESS }),
    onboardingKbAddErr: (err) => ({ type: actions.ONBOARDING_KB_ADD_ERR, err }),

    onboardingKbUpdateBegin: () => ({ type: actions.ONBOARDING_KB_UPDATE_BEGIN }),
    onboardingKbUpdateSuccess: () => ({ type: actions.ONBOARDING_KB_UPDATE_SUCCESS }),
    onboardingKbUpdateErr: (err) => ({ type: actions.ONBOARDING_KB_UPDATE_ERR, err }),

    onboardingKbDeleteBegin: () => ({ type: actions.ONBOARDING_KB_DELETE_BEGIN }),
    onboardingKbDeleteSuccess: () => ({ type: actions.ONBOARDING_KB_DELETE_SUCCESS }),
    onboardingKbDeleteErr: (err) => ({ type: actions.ONBOARDING_KB_DELETE_ERR, err }),

    onboardingKbSyncBegin: () => ({ type: actions.ONBOARDING_KB_SYNC_BEGIN }),
    onboardingKbSyncSuccess: () => ({ type: actions.ONBOARDING_KB_SYNC_SUCCESS }),
    onboardingKbSyncErr: (err) => ({ type: actions.ONBOARDING_KB_SYNC_ERR, err }),
};

export default actions;
